<template>
    <el-card class="main-card">
        <template #header>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item :to="{ path: '/' }">办公系统</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: '/workflow/flowArticle' }">发文管理</el-breadcrumb-item>
            </el-breadcrumb>
        </template>
        <el-form :model="query" ref="query" label-width="90px" class="search-form">
            <el-row>
                <el-form-item label="关键词" prop="keyword">
                    <el-col style="width: 150px">
                        <el-input v-model="query.keyword" @keyup.enter="fetchs" prefix-icon="Search"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item label="栏目" prop="articleType">
                    <el-col>
                        <el-select v-model="articleType" style="width: 180px;" clearable @change="fetchs">
                            <el-option label="推荐" value="推荐">
                                <span style="float: left">推荐</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    推荐文章
                                </span>
                            </el-option>
                            <el-option label="热门" value="热门">
                                <span style="float: left">热门</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    热门文章
                                </span>
                            </el-option>
                            <el-option label="公告" value="公告">
                                <span style="float: left">公告</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    公司通告
                                </span>
                            </el-option>
                            <el-option label="通知" value="通知">
                                <span style="float: left">通知</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    公共通知
                                </span>
                            </el-option>
                            <el-option label="月刊" value="月刊">
                                <span style="float: left">月刊</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    内部月刊
                                </span>
                            </el-option>
                            <el-option label="指引" value="指引">
                                <span style="float: left">指引</span>
                                <span style="float: right;color: var(--el-text-color-secondary);font-size: 13px;">
                                    系统操作指引
                                </span>
                            </el-option>
                        </el-select>
                    </el-col>
                </el-form-item>
                <el-form-item label="发布状态" prop="status">
                    <el-col>
                        <el-select v-model="status" placeholder="请选择状态" @change="fetchs" clearable style="width: 150px">
                            <el-option key="草稿" label="草稿" value="0"></el-option>
                            <el-option key="待审核" label="待审核" value="1"></el-option>
                            <el-option key="已发布" label="已发布" value="20"></el-option>
                            <el-option key="未通过" label="未通过" value="-1"></el-option>
                        </el-select>
                    </el-col>
                </el-form-item>

                <el-form-item label="" label-width="20px">
                    <el-button type="primary" icon="Search" @click="fetchs()">
                        搜索
                    </el-button>
                </el-form-item>
            </el-row>
        </el-form>

        <div class="toolbar">
            <el-button type="primary" icon="CirclePlus"
                @click="$router.push({ path: 'articlePusher', query: {} })">发布</el-button>
            <el-button type="success" icon="CircleCheckFilled" @click="auditor()">审核</el-button>
            <el-button type="warning" icon="Promotion" @click="retryNoticePush()">推送</el-button>

            <el-button plain icon="StarFilled" @click="$router.push({ path: 'articlePaper', query: { type: '月刊' } })"
                style="margin-left: 30px;">内部月刊</el-button>
        </div>

        <basic-table ref="table" class="table" :query="query" @handler="fetchs">
            <template v-slot:status="scope">
                <el-text v-if="scope.row.status == 0" type="info" size="small" disabled>草稿</el-text>
                <el-text v-else-if="scope.row.status == 1" type="primary" size="small" disabled>待审核</el-text>
                <el-text v-else-if="scope.row.status == 20" type="success" size="small" disabled>已发布</el-text>
                <el-text v-else-if="scope.row.status == -1" type="danger" size="small" disabled>未通过</el-text>
                <el-text v-else type="info" size="small" disabled>其他</el-text>
            </template>

            <template v-slot:noticePushEnabled="scope">
                <el-text v-if="scope.row.noticePushEnabled" type="success" size="small" disabled>是</el-text>
                <el-text v-else type="info" size="small" disabled>否</el-text>
            </template>

            <template v-slot:toolbar="scope">
                <el-text @click="watcher(scope.row)" type="primary" size="small"
                    style="margin:5px; cursor: pointer;">查看</el-text>
                <el-text @click="modify(scope.row)" type="primary" size="small"
                    style="margin:5px; cursor: pointer;">编辑</el-text>
                <el-text @click="deleter(scope.row)" type="primary" size="small"
                    style="margin:5px; cursor: pointer;">删除</el-text>
            </template>
        </basic-table>
    </el-card>
</template>

<script>
import { h } from 'vue';
import StaticDialog from "@/components/static-dialog.vue";
import BasicTable from "@/components/basic-table.vue";
export default {
    name: "FlowArticle",
    components: { StaticDialog, BasicTable },
    data() {
        return {
            query: {
                keyword: "",
                columns: [
                    { type: "selection", width: "55" },
                    { type: "index", label: "序号" },

                    { prop: "title", label: "标题", searchable: true, width: "220", showOverflowTooltip: true, },
                    { prop: "subTitle", label: "副标题", searchable: true, width: "220", showOverflowTooltip: true, },
                    { prop: "articleType", label: "类型", searchable: true, width: "90", showOverflowTooltip: true, },
                    { prop: "publishDate", label: "发布时间", width: "150", sortable: true, showOverflowTooltip: true },
                    { prop: "expiryDate", label: "有效期至", width: "160", sortable: true, showOverflowTooltip: true },
                    { prop: "publishDeptName", label: "发布部门", searchable: true, width: "90", showOverflowTooltip: true },
                    { prop: "publishUserName", label: "发布人", searchable: true, width: "90", showOverflowTooltip: true },
                    { type: "template", prop: "status", label: "状态", width: "70", searchable: true, },
                    { type: "template", prop: "noticePushEnabled", label: "是否推送", width: "90", searchable: true, },

                    { prop: "readCount", label: "阅读数", width: "90", },
                    { prop: "likeCount", label: "点赞数", width: "90", },
                    { prop: "commentCount", label: "评论数", width: "90", },

                    { prop: "createDate", label: "创建时间", width: "150", sortable: true, showOverflowTooltip: true },
                    { prop: "createUserName", label: "创建人", width: "80", },
                    { type: "toolbar", label: "操作", width: "180" },
                ],
                filters: [],
                sidx: "id",
                sord: "desc"
            },

            articleType: '',
            status: '',
        };
    },
    mounted() {
        //kaung插件初始化
        this.$kaung.init(this.$options.name);
        this.fetchs();
    },
    methods: {
        fetchs() {
            this.query.filters = [];
            if (this.articleType) {
                this.query.filters.push({ name: "articleType", value: this.articleType, operate: 0, });
            }
            if (this.status !== '' && this.status !== null && this.status !== undefined) {
                this.query.filters.push({ name: "status", value: this.status, operate: 0, });
            }

            let { data, records, total, ...params } = { ...this.query };
            this.$kaung.search(params).then((res) => {
                this.query = { ...res.data };
            });
        },
        auditor(rowId) {
            let rowIds = [];

            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];//去重
            if (rowIds.length == 0) {
                this.$kaung.message('请选择或者勾选其中一个要操作的数据');
                return;
            }


            // 使用 Vue 的 h 函数来创建虚拟 DOM 节点
            const selectOptions = [
                { value: '1', label: '审核通过' },
                { value: '-1', label: '审核驳回' },
            ];
            let selectValue = selectOptions[0].value;
            this.$alert(h('div', {}, [
                h('select', {
                    style: 'width: 150px',
                    onChange: (event) => {
                        console.log('Selected:', event.target.value);
                        selectValue = event.target.value;
                    }
                }, selectOptions.map(option =>
                    h('option', { value: option.value }, option.label)
                )),
            ]), {
                title: '请选择要执行的操作',
                dangerouslyUseHTMLString: true,
                showCancelButton: true,
                confirmButtonText: '确认',
                cancelButtonText: '取消'
            }).then((action) => {
                //console.log(action, selectValue); // 打印用户点击的是确认按钮还是取消按钮
                if (action == 'confirm') {
                    console.log(selectValue);
                    this.$kaung.fetch({
                        url: '/FlowArticle/Auditor',
                        method: 'post',
                        params: {
                            ids: rowIds.join(','),
                            operate: selectValue,
                        }
                    }).then((res) => {
                        if (res.code === 200) {
                            this.$kaung.success(res.content);
                            this.fetchs();
                        } else {
                            this.$kaung.error(res.content);
                        }
                    });
                }
            });
        },
        watcher(row) {
            this.$router.push({ path: 'articleDetail', query: { id: row.id } });
        },
        modify(row) {
            this.$router.push({ path: 'articlePusher', query: { id: row.id } });
        },
        retryNoticePush(rowId) {
            let rowIds = [];
            rowId = rowId || '';
            if (rowId == null || rowId == '') {
                if (this.$refs.table.chooseRow)
                    rowIds.push(this.$refs.table.chooseRow.id);
                if (this.$refs.table.selectIds && this.$refs.table.selectIds.length > 0)
                    rowIds.push(...this.$refs.table.selectIds);
            } else {
                rowIds.push(rowId);
            }
            rowIds = [...new Set(rowIds)];
            if (rowIds.length !== 1) {
                this.$kaung.message('请先选择一条要推送的数据');
                return;
            }
            this.$confirm(
                '该功能仅用于“审核成功但推送公告失败”或需补推场景，继续执行可能导致重复推送，是否继续？',
                '推送公告提示',
                { confirmButtonText: '继续推送', cancelButtonText: '取消', type: 'warning' }
            ).then(() => {
                this.$kaung.fetch({
                    url: '/FlowArticle/RetryNoticePush',
                    method: 'post',
                    params: { id: rowIds[0] }
                }).then((res) => {
                    if (res.code === 200) {
                        this.$kaung.success(res.content || '推送成功');
                    } else {
                        this.$kaung.error(res.content || '推送失败');
                    }
                });
            }).catch(() => { });
        },
        deleter(row) {
            let that = this;
            this.$confirm("此操作将删除本页选择数据, 是否继续?", "提示", { confirmButtonText: "确定", cancelButtonText: "取消", type: "warning", })
                .then(() => {
                    this.$kaung.delete(row.id).then((res) => {
                        if (res.code === 200) {
                            this.$kaung.success(res.content);
                            this.fetchs();
                        } else {
                            this.$kaung.error(res.content);
                        }
                    });
                });
        },
    },
    watch: {

    },
    created: function () {
        this.query.keyword = this.$util.getPageCache('keyword');
    }
};
</script>

<style lang="less"></style>
